import { Box } from "@mui/material";
import { useBaseForm } from "./hooks/useBaseForm";
import { IFormConfig } from "./interface/form.interfaces";
import { FormField } from "./components/FormField";

export const BaseForm = ({
  fields,
  defaultValues,
  columns = 1,
  submitLabel = "Submit",
  onSubmit,
  onFieldChange,
  onAddressSelect,
  styles,
}: IFormConfig) => {
  const { values, errors, isSubmitting, handleChange, handleBlur, handleSubmit } = useBaseForm({
    fields,
    defaultValues,
    onSubmit,
    onFieldChange,
  });

  return (
    <form onSubmit={handleSubmit} noValidate>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            md: `repeat(${columns}, 1fr)`,
          },
          gap: "1rem",
          ...styles?.container,
        }}
      >
        {fields.map((field) => (
          <FormField
            key={field.name}
            field={field}
            value={values[field.name]}
            error={errors[field.name]}
            onChange={handleChange}
            onBlur={handleBlur}
            styles={styles}
            onAddressSelect={
              onAddressSelect
                ? (addressData) => {
                    onAddressSelect(addressData, (name, value) => {
                      handleChange(name, value);
                    });
                  }
                : undefined
            }
          />
        ))}
      </Box>

      <button type="submit" disabled={isSubmitting} style={{ ...styles.submitButton }}>
        {isSubmitting ? "Submitting…" : submitLabel}
      </button>
    </form>
  );
};
